




import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import Vue from 'vue';

import HeaderMixins from './mixins';

@Component
export default class Header extends mixins(Vue, HeaderMixins) {}
